import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { company, navLinks } from '../data/company';
import { brand, serif } from '../theme';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: brand.ink,
    color: 'rgba(255,255,255,0.65)',
    padding: theme.spacing(10, 0, 4),
    paddingBottom: `calc(${theme.spacing(4)}px + env(safe-area-inset-bottom, 0px))`,
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(7),
    },
  },
  cta: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    paddingBottom: theme.spacing(6),
    borderBottom: '1px solid rgba(255,255,255,0.14)',
  },
  ctaText: {
    fontFamily: serif,
    color: '#FFFFFF',
    fontSize: 'clamp(2rem, 5vw, 3.75rem)',
    lineHeight: 1.05,
    letterSpacing: '-0.02em',
    margin: 0,
    maxWidth: 640,
    '& em': {
      color: '#E2A58F',
    },
  },
  phone: {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#FFFFFF',
    fontSize: '1.25rem',
    fontWeight: 500,
    textDecoration: 'none',
    paddingBottom: 4,
    borderBottom: '1px solid #E2A58F',
    '& svg': {
      marginLeft: 10,
      color: '#E2A58F',
      transition: 'transform 200ms ease',
    },
    '&:hover svg': {
      transform: 'translateX(4px)',
    },
  },
  bottom: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(4),
    // Medium screens: name and links on one row, copyright below.
    // Wide screens: all three on one row.
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gap: theme.spacing(3, 6),
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'auto 1fr auto',
      gap: theme.spacing(6),
    },
  },
  wordmark: {
    fontFamily: serif,
    color: '#FFFFFF',
    fontSize: '1.25rem',
  },
  links: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1, 3),
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& a': {
      color: 'inherit',
      textDecoration: 'none',
      '&:hover': {
        color: '#FFFFFF',
      },
    },
  },
  legal: {
    fontSize: '0.85rem',
    [theme.breakpoints.only('md')]: {
      gridColumn: '1 / -1',
    },
  },
}));

export default function Footer() {
  const classes = useStyles();
  const year = new Date().getFullYear();

  return (
    <Box component="footer" className={classes.footer}>
      <Container maxWidth="lg">
        <div className={classes.cta}>
          <p className={classes.ctaText}>
            Ready to start your project? <em>Let's talk.</em>
          </p>
          <a href={company.phoneHref} className={classes.phone}>
            {company.phoneDisplay}
            <ArrowForwardIcon />
          </a>
        </div>
        <div className={classes.bottom}>
          <span className={classes.wordmark}>{company.name}</span>
          <nav aria-label="Footer">
            <ul className={classes.links}>
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </nav>
          <Typography component="span" className={classes.legal}>
            © {year} {company.name}. All rights reserved.
          </Typography>
        </div>
      </Container>
    </Box>
  );
}
